<template>
    <div
        class="w-full h-full inset-0 flex items-center justify-center bg-hh-grey-50/40 z-70 duration-100"
        :class="{
            'pointer-events-none opacity-0': ! this.isLoading(),
            'opacity-80': this.isLoading(),
            'fixed': this.isFullScreen,
            'absolute': ! this.isFullScreen,
        }"
    >
        <div class="w-40 h-40 logo-loader"></div>
    </div>
</template>

<script>

import {getBoolFromAttribute} from "@/frontend-v3/Utils";

export default {

    name: 'LoadingOverlayLogo',

    props: [
        'fullScreen',
        'reference'
    ],

    data() {
        return {
            loadingEvents: [],
            isFullScreen: true,
        }
    },

    created() {
        this.isFullScreen = this.fullScreen === undefined || getBoolFromAttribute(this.fullScreen);

        this.Bus.on('start-loading', (reference) => {
            // If we have a specific reference set up...
            if (this.reference) {
                // Check if the name matches
                if (this.reference !== reference) {
                    // this one isn't meant for us
                    return;
                }
            }

            if (! this.loadingEvents.includes(reference)) {
                this.loadingEvents.push(reference);
            }

            this.debug();
        });

        this.Bus.on('stop-loading', (reference) => {

            if (this.loadingEvents.includes(reference)) {
                this.loadingEvents = this.loadingEvents.filter(item => item !== reference);
            }

            this.debug();
        });
    },

    methods: {

        debug() {
            this.Bus.emit('debug', 'loading events: (' + this.loadingEvents.count + '), isLoading: ' + (this.isLoading() ? 1 : 0));
        },

        isLoading() {
            return this.loadingEvents.length > 0;
        },
    },
};
</script>
